import React, { useEffect, useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../../context/CartContext';
import { useAuthUser } from '../../context/AuthUserContext';
import ModalRelacionado from '../CursoDetalle/ModalRelacionado';

const API = 'https://centrocomunicar.com/api-comunicar/endpoints/relacionados_admin.php';

const soles   = (n) => `S/. ${Number(n || 0).toFixed(2)}`;
const cartIdDe = (p) => p.tipo === 'curso' ? 'curso-' + p.id : p.id;

const IconCart  = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><circle cx="9" cy="21" r="1" stroke="currentColor" strokeWidth="2"/><circle cx="20" cy="21" r="1" stroke="currentColor" strokeWidth="2"/><path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconUsers = () => (<svg viewBox="0 0 24 24" fill="none" width="12" height="12"><circle cx="9" cy="7" r="3.2" stroke="currentColor" strokeWidth="2"/><path d="M3 21v-1.5A4 4 0 017 15.5h4a4 4 0 014 4V21" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconClock = () => (<svg viewBox="0 0 24 24" fill="none" width="12" height="12"><circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2"/><path d="M12 7v5l3 2" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconAge   = () => (<svg viewBox="0 0 24 24" fill="none" width="12" height="12"><circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2"/><path d="M9 10h.01M15 10h.01M8.5 14.5a4.5 4.5 0 007 0" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);

/* Título a dos colores con línea, como el diseño */
export const TituloSeccion = ({ a, b }) => (
  <div style={{ marginBottom: '1.1rem' }}>
    <h2 style={{ fontSize: '1.45rem', fontWeight: 800, color: '#2b3a40', margin: 0, letterSpacing: '-.01em' }}>
      {a} <span style={{ color: '#8bcaaf' }}>{b}</span>
    </h2>
    <div style={{ height: 1, background: 'rgba(130,216,179,.5)', marginTop: '.55rem' }} />
  </div>
);

/* Metadatos cortos bajo la imagen */
function metaDe(p) {
  const m = [];
  if (p.jugadores_min || p.jugadores_max) {
    const t = p.jugadores_min && p.jugadores_max
      ? (p.jugadores_min === p.jugadores_max ? `${p.jugadores_min}` : `${p.jugadores_min} - ${p.jugadores_max}`)
      : `${p.jugadores_min || p.jugadores_max}`;
    m.push({ icon: <IconUsers/>, txt: `${t} jugadores` });
  }
  if (p.duracion_min || p.duracion_max) {
    const t = p.duracion_min && p.duracion_max && p.duracion_min !== p.duracion_max
      ? `${p.duracion_min}-${p.duracion_max} min` : `${p.duracion_min || p.duracion_max} min`;
    m.push({ icon: <IconClock/>, txt: t });
  }
  if (p.edad_minima) m.push({ icon: <IconAge/>, txt: `${p.edad_minima}+ años` });
  if (m.length === 0) {
    if (p.formato) m.push({ icon: null, txt: p.formato });
    if (p.paginas) m.push({ icon: null, txt: `${p.paginas} págs.` });
  }
  return m.slice(0, 3);
}

function Tarjeta({ p, enCarrito, onAgregar, onVerDetalle }) {
  const conDto = p.descuento_pct > 0;
  const meta   = metaDe(p);

  return (
    <article style={{
      background:'#fff', borderRadius:6, overflow:'hidden',
      border:'1px solid rgba(0,0,0,.07)', boxShadow:'0 2px 12px rgba(0,0,0,.05)',
      display:'flex', flexDirection:'column',
    }}>
      <div
        onClick={() => onVerDetalle(p)}
        style={{ position:'relative', width:'100%', aspectRatio:'1/1', background:'#f3f8f5', cursor:'pointer' }}>
        {p.imagen_url
          ? <img src={p.imagen_url} alt={p.titulo} style={{ width:'100%', height:'100%', objectFit:'cover' }}/>
          : <div style={{ width:'100%', height:'100%', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'2rem' }}>
              {p.tipo === 'curso' ? '🎓' : '📄'}
            </div>}
        {conDto && (
          <span style={{
            position:'absolute', top:0, left:0,
            background:'#e63946', color:'#fff',
            fontSize:'.7rem', fontWeight:800,
            padding:'.3rem .6rem', borderBottomRightRadius:6,
          }}>
            −{Math.round(p.descuento_pct)}%
          </span>
        )}
      </div>

      <div style={{ padding:'.7rem .8rem .9rem', display:'flex', flexDirection:'column', gap:'.35rem', flex:1 }}>
        {meta.length > 0 && (
          <div style={{ display:'flex', gap:'.6rem', flexWrap:'wrap', color:'#5a6a63', fontSize:'.66rem', fontWeight:600 }}>
            {meta.map((m, i) => (
              <span key={i} style={{ display:'inline-flex', alignItems:'center', gap:'.22rem' }}>{m.icon}{m.txt}</span>
            ))}
          </div>
        )}

        <strong
          onClick={() => onVerDetalle(p)}
          style={{ fontSize:'.84rem', fontWeight:700, color:'#111614', lineHeight:1.3, cursor:'pointer' }}>
          {p.titulo}
        </strong>

        <div style={{ marginTop:'auto', paddingTop:'.3rem' }}>
          {conDto ? (
            <div style={{ display:'flex', alignItems:'baseline', gap:'.4rem' }}>
              <s style={{ fontSize:'.72rem', color:'#9ca3af' }}>{soles(p.precio)}</s>
              <span style={{ fontSize:'.85rem', fontWeight:800, color:'#14736C' }}>{soles(p.precio_paquete)}</span>
            </div>
          ) : (
            <span style={{ fontSize:'.85rem', fontWeight:700, color:'#5a6a63' }}>{soles(p.precio)}</span>
          )}
        </div>

        {enCarrito ? (
          <button onClick={() => onVerDetalle(p, true)}
            style={{ marginTop:'.5rem', width:'100%', background:'#edfaf4', color:'#14736C', border:'1.5px solid rgba(130,216,179,.5)', borderRadius:4, padding:'.5rem', fontFamily:'inherit', fontWeight:700, fontSize:'.78rem', cursor:'pointer' }}>
            ✓ En el carrito
          </button>
        ) : (
          <button onClick={() => onAgregar(p)}
            style={{ marginTop:'.5rem', width:'100%', display:'flex', alignItems:'center', justifyContent:'center', gap:'.4rem', background:'#2e8b73', color:'#fff', border:'none', borderRadius:4, padding:'.55rem', fontFamily:'inherit', fontWeight:700, fontSize:'.78rem', cursor:'pointer' }}>
            <IconCart/> Añadir al carrito
          </button>
        )}
      </div>
    </article>
  );
}

export default function SeccionRelacionados({ origenTipo, origenId, origenTitulo, origenPrecio, origenImagen, redirectLogin }) {
  const [items,      setItems]      = useState([]);
  const [cargando,   setCargando]   = useState(true);
  const [verDetalle, setVerDetalle] = useState(null);

  const navigate = useNavigate();
  const { agregarItem, estaEnCarrito } = useCart();
  const { estaLogueado } = useAuthUser();

  useEffect(() => {
    let vivo = true;
    fetch(`${API}?action=publicos&origen_tipo=${origenTipo}&origen_id=${origenId}`)
      .then(r => r.json())
      .then(j => { if (vivo) setItems(j.success ? (j.data || []) : []); })
      .catch(() => {})
      .finally(() => { if (vivo) setCargando(false); });
    return () => { vivo = false; };
  }, [origenTipo, origenId]);

  const similares = useMemo(() => items.filter(p => !(p.descuento_pct > 0)), [items]);
  const paquete   = useMemo(() => items.filter(p =>   p.descuento_pct > 0),  [items]);
  const dtoMax    = paquete.reduce((a, p) => Math.max(a, p.descuento_pct), 0);

  const exigirLogin = () => {
    if (estaLogueado) return false;
    navigate(redirectLogin || '/login');
    return true;
  };

  /* Suelto, a precio de lista */
  const agregarSuelto = (p) => {
    if (exigirLogin()) return;
    agregarItem({
      id: cartIdDe(p), titulo: p.titulo, precio: p.precio,
      tipo: p.tipo === 'curso' ? 'curso' : 'recurso',
      color: 'verde', imagen: p.imagen_url || null, digital: true,
    });
  };

  /* Junto al producto principal → con descuento */
  const agregarJunto = (p) => {
    if (exigirLogin()) return;
    const idOrigen = cartIdDe({ tipo: origenTipo, id: origenId });
    if (!estaEnCarrito(idOrigen) && Number(origenPrecio) > 0) {
      agregarItem({
        id: idOrigen, titulo: origenTitulo, precio: Number(origenPrecio),
        tipo: origenTipo === 'curso' ? 'curso' : 'recurso',
        color: 'verde', imagen: origenImagen || null, digital: true,
      });
    }
    agregarItem({
      id: cartIdDe(p), titulo: p.titulo,
      precio: p.precio_paquete, precio_lista: p.precio,
      descuento_pct: p.descuento_pct, paquete_de: idOrigen,
      tipo: p.tipo === 'curso' ? 'curso' : 'recurso',
      color: 'verde', imagen: p.imagen_url || null, digital: true,
    });
  };

  if (cargando || items.length === 0) return null;

  const grid = {
    display:'grid',
    gridTemplateColumns:'repeat(auto-fill, minmax(190px, 1fr))',
    gap:'1.1rem',
  };

  return (
    <>
      {similares.length > 0 && (
        <section style={{ marginBottom:'2.8rem' }}>
          <TituloSeccion a="Productos" b="similares"/>
          <p style={{ margin:'-.6rem 0 1.2rem', fontSize:'.86rem', color:'#5a6a63' }}>
            Descubre otros materiales que también podrían gustarte.
          </p>
          <div style={grid}>
            {similares.map(p => (
              <Tarjeta key={cartIdDe(p)} p={p}
                enCarrito={estaEnCarrito(cartIdDe(p))}
                onAgregar={agregarSuelto}
                onVerDetalle={(x, ir) => ir ? navigate('/carrito') : setVerDetalle(x)}/>
            ))}
          </div>
        </section>
      )}

      {paquete.length > 0 && (
        <section style={{ marginBottom:'2.8rem' }}>
          <TituloSeccion a="Llévalos" b="juntos"/>
          <p style={{ margin:'-.6rem 0 1.2rem', fontSize:'.86rem', color:'#5a6a63' }}>
            Aprovecha hasta {Math.round(dtoMax)}% OFF al llevar estos productos junto con este.
          </p>
          <div style={grid}>
            {paquete.map(p => (
              <Tarjeta key={cartIdDe(p)} p={p}
                enCarrito={estaEnCarrito(cartIdDe(p))}
                onAgregar={agregarJunto}
                onVerDetalle={(x, ir) => ir ? navigate('/carrito') : setVerDetalle(x)}/>
            ))}
          </div>
        </section>
      )}

      {verDetalle && (
        <ModalRelacionado
          producto={verDetalle}
          enCarrito={estaEnCarrito(cartIdDe(verDetalle))}
          onAgregar={verDetalle.descuento_pct > 0 ? agregarJunto : agregarSuelto}
          onVerCarrito={() => navigate('/carrito')}
          onCerrar={() => setVerDetalle(null)}/>
      )}
    </>
  );
}